<template>
    <q-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)" persistent>
        <q-card class="obra-crud-form" style="max-width: 95vw; height: 95vh; display: flex; flex-direction: column;">
            <!-- Header mejorado - FIJO -->
            <q-toolbar class="bg-gradient-primary text-white toolbar-fixed">
                <q-icon name="engineering" size="28px" class="q-mr-sm" />
                <q-toolbar-title>
                    <div class="text-h6">{{ operText }} Obra</div>
                    <div class="text-caption text-white-7">{{ input.referencia || 'Nueva obra' }}</div>
                </q-toolbar-title>

                <!-- Badge de validación -->
                <q-badge :color="res.valid ? 'positive' : 'warning'" :label="res.valid ? 'Válido' : 'Incompleto'"
                    class="q-mr-md">
                    <q-icon :name="res.valid ? 'check_circle' : 'error'" size="16px" class="q-ml-xs" />
                </q-badge>

                <q-btn dense flat icon="close" v-close-popup>
                    <q-tooltip>Cerrar (ESC)</q-tooltip>
                </q-btn>
            </q-toolbar>

            <!-- Contenido scrolleable -->
            <div class="row no-wrap content-scrollable">
                <!-- Columna principal: Formulario -->
                <div class="col-12 col-md-8 q-pa-md scroll-area">
                    <form @submit.prevent="validate">
                        <!-- Sección: Información Básica -->
                        <q-expansion-item default-opened icon="info" label="Información Básica"
                            caption="Datos principales de la obra"
                            header-class="bg-grey-2 text-primary text-weight-medium"
                            class="q-mb-md rounded-borders overflow-hidden">
                            <q-card flat bordered>
                                <q-card-section>
                                    <div class="row q-col-gutter-md">
                                        <div class="col-12 col-md-6">
                                            <GltnInput label="Referencia" v-model="input.referencia" name="referencia"
                                                @update:modelValue="validate($event, 'referencia')"
                                                :errors="res.getErrors('referencia')"
                                                :readonly="isEditable('referencia')">
                                                <template v-slot:prepend>
                                                    <q-icon name="tag" color="primary" />
                                                </template>
                                            </GltnInput>
                                        </div>
                                        <div class="col-12 col-md-6">
                                            <GltnSelectCliente label="Cliente" name="cliente_id"
                                                v-model="input.cliente_id"
                                                @update:modelValue="validate($event, 'cliente_id')"
                                                :errors="res.getErrors('cliente_id')" hide-hint emit-value map-options
                                                :readonly="isEditable('cliente_id')">
                                                <template v-slot:prepend>
                                                    <q-icon name="business" color="primary" />
                                                </template>
                                                <template v-slot:after v-if="oper !== 'view'">
                                                    <q-btn round unelevated icon="add" color="primary" size="sm"
                                                        @click="clienteOpenDialog = true">
                                                        <q-tooltip>Agregar cliente</q-tooltip>
                                                    </q-btn>
                                                </template>
                                            </GltnSelectCliente>
                                        </div>
                                    </div>

                                    <div class="row q-col-gutter-md">
                                        <div class="col-12 col-md-4">
                                            <GltnSelectVendedores label="Distribuidor" v-model="input.distribuidor_id"
                                                :readonly="isEditable('distribuidor_id')"
                                                :errors="res.getErrors('distribuidor_id')"
                                                @update:modelValue="validate($event, 'distribuidor_id')">
                                                <template v-slot:prepend>
                                                    <q-icon name="store" color="primary" />
                                                </template>
                                            </GltnSelectVendedores>
                                        </div>
                                        <div class="col-12 col-md-4">
                                            <GltnSelectSectorEconomico label="Sector Económico"
                                                v-model="input.sector_economico_id"
                                                @update:modelValue="validate($event, 'sector_economico_id')"
                                                :errors="res.getErrors('sector_economico_id')" hide-hint emit-value
                                                map-options :readonly="isEditable('sector_economico_id')">
                                                <template v-slot:prepend>
                                                    <q-icon name="domain" color="primary" />
                                                </template>
                                            </GltnSelectSectorEconomico>
                                        </div>
                                        <div class="col-12 col-md-4">
                                            <GltnInputNumber v-model.number="input.presupuestado" label="Presupuestado"
                                                prefix="U$S" hide-hint :readonly="isEditable('presupuestado')">
                                                <template v-slot:prepend>
                                                    <q-icon name="attach_money" color="primary" />
                                                </template>
                                            </GltnInputNumber>
                                        </div>
                                    </div>

                                    <div class="row q-col-gutter-md">
                                        <div class="col-12">
                                            <GltnInput label="Observaciones" v-model="input.observaciones"
                                                @update:modelValue="validate($event, 'observaciones')" type="textarea"
                                                rows="3" :readonly="isEditable('observaciones')">
                                                <template v-slot:prepend>
                                                    <q-icon name="notes" color="primary" />
                                                </template>
                                            </GltnInput>
                                        </div>
                                    </div>
                                </q-card-section>
                            </q-card>
                        </q-expansion-item>

                        <!-- Sección: Contacto Comercial -->
                        <q-expansion-item default-opened icon="business_center" label="Contacto Comercial"
                            caption="Información del contacto comercial"
                            header-class="bg-grey-2 text-primary text-weight-medium"
                            class="q-mb-md rounded-borders overflow-hidden">
                            <q-card flat bordered>
                                <q-card-section>
                                    <div class="row q-col-gutter-md">
                                        <div class="col-12 col-md-4">
                                            <GltnInput label="Nombre" v-model="input.contacto_comercial_nombre"
                                                @update:modelValue="validate($event, 'contacto_comercial_nombre')"
                                                :errors="res.getErrors('contacto_comercial_nombre')"
                                                :readonly="isEditable('contacto_comercial_nombre')">
                                                <template v-slot:prepend>
                                                    <q-icon name="person" color="blue" />
                                                </template>
                                            </GltnInput>
                                        </div>
                                        <div class="col-12 col-md-4">
                                            <GltnInput label="Teléfono" v-model="input.contacto_comercial_tel"
                                                @update:modelValue="validate($event, 'contacto_comercial_tel')"
                                                :errors="res.getErrors('contacto_comercial_tel')"
                                                :readonly="isEditable('contacto_comercial_tel')">
                                                <template v-slot:prepend>
                                                    <q-icon name="phone" color="blue" />
                                                </template>
                                            </GltnInput>
                                        </div>
                                        <div class="col-12 col-md-4">
                                            <GltnInput label="Email" v-model="input.contacto_comercial_email"
                                                type="email"
                                                @update:modelValue="validate($event, 'contacto_comercial_email')"
                                                :errors="res.getErrors('contacto_comercial_email')"
                                                :readonly="isEditable('contacto_comercial_email')">
                                                <template v-slot:prepend>
                                                    <q-icon name="email" color="blue" />
                                                </template>
                                            </GltnInput>
                                        </div>
                                    </div>
                                </q-card-section>
                            </q-card>
                        </q-expansion-item>

                        <!-- Sección: Contacto Logístico -->
                        <q-expansion-item default-opened icon="local_shipping" label="Contacto Logístico"
                            caption="Información del contacto logístico"
                            header-class="bg-grey-2 text-primary text-weight-medium"
                            class="q-mb-md rounded-borders overflow-hidden">
                            <q-card flat bordered>
                                <q-card-section>
                                    <div class="row q-col-gutter-md">
                                        <div class="col-12 col-md-4">
                                            <GltnInput label="Nombre" v-model="input.contacto_logistico_nombre"
                                                @update:modelValue="validate($event, 'contacto_logistico_nombre')"
                                                :errors="res.getErrors('contacto_logistico_nombre')"
                                                :readonly="isEditable('contacto_logistico_nombre')">
                                                <template v-slot:prepend>
                                                    <q-icon name="person" color="orange" />
                                                </template>
                                            </GltnInput>
                                        </div>
                                        <div class="col-12 col-md-4">
                                            <GltnInput label="Teléfono" v-model="input.contacto_logistico_tel"
                                                @update:modelValue="validate($event, 'contacto_logistico_tel')"
                                                :errors="res.getErrors('contacto_logistico_tel')"
                                                :readonly="isEditable('contacto_logistico_tel')">
                                                <template v-slot:prepend>
                                                    <q-icon name="phone" color="orange" />
                                                </template>
                                            </GltnInput>
                                        </div>
                                        <div class="col-12 col-md-4">
                                            <GltnInput label="Email" v-model="input.contacto_logistico_email"
                                                @update:modelValue="validate($event, 'contacto_logistico_email')"
                                                :errors="res.getErrors('contacto_logistico_email')" type="email"
                                                :readonly="isEditable('contacto_logistico_email')">
                                                <template v-slot:prepend>
                                                    <q-icon name="email" color="orange" />
                                                </template>
                                            </GltnInput>
                                        </div>
                                    </div>
                                </q-card-section>
                            </q-card>
                        </q-expansion-item>

                        <!-- Sección: Ubicación -->
                        <q-expansion-item default-opened icon="place" label="Ubicación de la Obra"
                            caption="Dirección y coordenadas" header-class="bg-grey-2 text-primary text-weight-medium"
                            class="rounded-borders overflow-hidden">
                            <q-card flat bordered>
                                <q-card-section>
                                    <div class="row q-col-gutter-md q-mb-md">
                                        <div class="col-12">
                                            <GltnAddressSearch label="Búsqueda de Dirección"
                                                @update:modelValue="setDireccion"
                                                placeholder="Escriba al menos 3 caracteres para buscar..." hide-hint>
                                                <template v-slot:prepend>
                                                    <q-icon name="search" color="primary" />
                                                </template>
                                            </GltnAddressSearch>
                                        </div>
                                    </div>

                                    <div class="row q-col-gutter-md q-mb-md">
                                        <div class="col-12 col-md-6">
                                            <GltnInput label="Dirección" :model-value="input.direccion"
                                                @update:modelValue="validate($event, 'direccion')"
                                                :errors="res.getErrors('direccion')" hide-hint readonly filled
                                                bg-color="blue-1">
                                                <template v-slot:prepend>
                                                    <q-icon name="location_on" color="primary" />
                                                </template>
                                            </GltnInput>
                                        </div>
                                        <div class="col-12 col-md-3">
                                            <GltnInput label="Latitud" :model-value="input.latitud" readonly filled
                                                bg-color="blue-1">
                                                <template v-slot:prepend>
                                                    <q-icon name="pin_drop" />
                                                </template>
                                            </GltnInput>
                                        </div>
                                        <div class="col-12 col-md-3">
                                            <GltnInput label="Longitud" :model-value="input.longitud" readonly filled
                                                bg-color="blue-1">
                                                <template v-slot:prepend>
                                                    <q-icon name="pin_drop" />
                                                </template>
                                            </GltnInput>
                                        </div>
                                    </div>

                                    <div class="map-container">
                                        <GoogleMap ref="mapRef" :api-key="apiKey"
                                            style="width: 100%; height: 400px; border-radius: 8px;" :center="center"
                                            :zoom="mapZoom" @click="onMapClick">
                                            <Marker :options="{ position: center }" />
                                        </GoogleMap>
                                    </div>
                                </q-card-section>
                            </q-card>
                        </q-expansion-item>
                    </form>
                </div>

                <!-- Columna lateral: Resumen -->
                <div class="col-12 col-md-4 bg-grey-1 q-pa-md gt-sm scroll-area">
                    <div class="sticky-summary">
                        <q-card flat bordered class="summary-card">
                            <q-card-section class="bg-primary text-white">
                                <div class="text-h6">
                                    <q-icon name="summarize" class="q-mr-sm" />
                                    Resumen
                                </div>
                            </q-card-section>

                            <q-separator />

                            <q-card-section>
                                <!-- Información básica -->
                                <div class="summary-section">
                                    <div class="text-subtitle2 text-grey-8 q-mb-sm">
                                        <q-icon name="info" size="18px" class="q-mr-xs" />
                                        Información General
                                    </div>
                                    <div class="summary-row" v-if="input.referencia">
                                        <span class="text-grey-7">Referencia:</span>
                                        <span class="text-weight-medium">{{ input.referencia }}</span>
                                    </div>
                                    <div class="summary-row" v-if="input.cliente_id">
                                        <span class="text-grey-7">Cliente:</span>
                                        <span class="text-weight-medium">{{ input.cliente_id.label || input.cliente_id
                                            }}</span>
                                    </div>
                                    <div class="summary-row" v-if="input.presupuestado">
                                        <span class="text-grey-7">Presupuestado:</span>
                                        <span class="text-primary text-weight-bold">U$S {{ input.presupuestado }}</span>
                                    </div>
                                </div>

                                <q-separator class="q-my-md" />

                                <!-- Contactos -->
                                <div class="summary-section">
                                    <div class="text-subtitle2 text-grey-8 q-mb-sm">
                                        <q-icon name="contacts" size="18px" class="q-mr-xs" />
                                        Contactos
                                    </div>
                                    <div v-if="input.contacto_comercial_nombre || input.contacto_comercial_tel">
                                        <div class="text-caption text-blue-9 text-weight-bold q-mb-xs">Comercial</div>
                                        <div class="summary-row" v-if="input.contacto_comercial_nombre">
                                            <q-icon name="person" size="14px" color="blue" />
                                            <span class="text-caption">{{ input.contacto_comercial_nombre }}</span>
                                        </div>
                                        <div class="summary-row" v-if="input.contacto_comercial_tel">
                                            <q-icon name="phone" size="14px" color="blue" />
                                            <span class="text-caption">{{ input.contacto_comercial_tel }}</span>
                                        </div>
                                    </div>
                                    <div v-if="input.contacto_logistico_nombre || input.contacto_logistico_tel"
                                        class="q-mt-sm">
                                        <div class="text-caption text-orange-9 text-weight-bold q-mb-xs">Logístico</div>
                                        <div class="summary-row" v-if="input.contacto_logistico_nombre">
                                            <q-icon name="person" size="14px" color="orange" />
                                            <span class="text-caption">{{ input.contacto_logistico_nombre }}</span>
                                        </div>
                                        <div class="summary-row" v-if="input.contacto_logistico_tel">
                                            <q-icon name="phone" size="14px" color="orange" />
                                            <span class="text-caption">{{ input.contacto_logistico_tel }}</span>
                                        </div>
                                    </div>
                                </div>

                                <q-separator class="q-my-md" />

                                <!-- Ubicación -->
                                <div class="summary-section">
                                    <div class="text-subtitle2 text-grey-8 q-mb-sm">
                                        <q-icon name="place" size="18px" class="q-mr-xs" />
                                        Ubicación
                                    </div>
                                    <div class="summary-row" v-if="input.direccion">
                                        <q-icon name="location_on" size="16px" color="primary" />
                                        <span class="text-caption">{{ input.direccion }}</span>
                                    </div>
                                    <div class="summary-row" v-if="input.latitud && input.longitud">
                                        <q-icon name="map" size="16px" color="primary" />
                                        <span class="text-caption">{{ input.latitud }}, {{ input.longitud }}</span>
                                    </div>
                                </div>
                            </q-card-section>

                            <q-separator />

                            <q-card-section class="q-pa-sm">
                                <q-linear-progress :value="validationProgress" color="positive" size="8px" rounded
                                    class="q-mb-xs" />
                                <div class="text-caption text-center text-grey-7">
                                    Formulario {{ Math.round(validationProgress * 100) }}% completo
                                </div>
                            </q-card-section>
                        </q-card>

                        <!-- Tips útiles -->
                        <q-card flat bordered class="q-mt-md">
                            <q-card-section class="bg-blue-1">
                                <div class="row items-center">
                                    <q-icon name="lightbulb" color="amber" size="24px" class="q-mr-sm" />
                                    <span class="text-weight-medium">Tips</span>
                                </div>
                            </q-card-section>
                            <q-card-section>
                                <ul class="q-pl-md text-caption text-grey-7">
                                    <li>Busque la dirección usando el campo de búsqueda</li>
                                    <li>Haga clic en el mapa para ajustar la ubicación</li>
                                    <li>Complete los datos del cliente para autocompletar contactos</li>
                                </ul>
                            </q-card-section>
                        </q-card>
                    </div>
                </div>
            </div>

            <!-- Footer con acciones - FIJO -->
            <q-separator />
            <q-card-actions class="q-pa-md actions-fixed bg-white">
                <div class="row full-width q-gutter-sm">
                    <div class="col">
                        <q-btn outline label="Cancelar" color="grey-7" icon="close" v-close-popup class="full-width" />
                    </div>
                    <div class="col" v-if="oper !== 'view'">
                        <q-btn unelevated label="Guardar" :color="res.valid ? 'primary' : 'grey'" icon="save"
                            @click="save" :disable="!res.valid" :loading="loading" class="full-width">
                            <template v-slot:loading>
                                <q-spinner-hourglass size="20px" />
                            </template>
                        </q-btn>
                    </div>
                </div>
            </q-card-actions>

            <q-inner-loading :showing="loading">
                <q-spinner-hourglass size="50px" color="primary" />
            </q-inner-loading>
        </q-card>
    </q-dialog>
    <ClienteCrud v-model="clienteOpenDialog" oper="add" @updated="clienteUpdated" />
</template>

<script setup>
import ClienteCrud from "../cliente/ClienteCrud.vue";
import ClienteService from "@/services/ClienteService.js";
import GltnInput from "../form/GltnInput.vue";
import GltnInputNumber from "../form/GltnInputNumber.vue";
import GltnAddressSearch from "../form/GltnAddressSearch.vue";
import GltnSelectCliente from "../form/GltnSelectCliente.vue";
import GltnSelectSectorEconomico from "../form/GltnSelectSectorEconomico.vue";
import GltnSelectVendedores from "../form/GltnSelectVendedores.vue";
import ObraService from "@/services/ObraService.js";
import suite from "./ObraCrudValidation.js";
import { GoogleMap, Marker } from "vue3-google-map";
import { reactive, ref, computed, onMounted, watchEffect } from "vue";
import { useQuasar } from "quasar";

const $q = useQuasar();
const props = defineProps({
    oper: [String],
    modelValue: {
        type: Boolean,
        default: false,
    },
    id: {
        type: [String, Number],
        default: null,
    },
});
const emits = defineEmits(["update:modelValue", "updated", "stored"]);

const operText = computed(() => {
    switch (props.oper) {
        case "add":
            return "Crear";
        case "edit":
            return "Editar";
        case "view":
            return "Ver";
        default:
            return "Ver"
    }
});

const clienteOpenDialog = ref(false);
const directionSearchShow = ref(false)
const camposEditables = ['sector_economico_id', 'distribuidor_id'];

const isEditable = (campo) => {
    if (props.oper === 'view' || props.oper === 'add') return false;
    if (props.oper === 'edit' && props.id) {
        return camposEditables.includes(campo);
    }
    return true;
};

const input = reactive({
    cliente_id: "",
    contactoComercialId: "",
    contactoLogisisticoId: "",
    sector_economico_id: "",
    direccion: "",
    latitud: "",
    longitud: "",
    segmentacionId: "",
    observaciones: "",
    referencia: "",
    contacto_comercial_nombre: "",
    contacto_comercial_tel: "",
    contacto_comercial_email: "",
    contacto_logistico_nombre: "",
    contacto_logistico_tel: "",
    contacto_logistico_email: "",
    distribuidor_id: null,
    presupuestado: 0,
});

// VALIDACION
const res = ref();
const loading = ref(false);
res.value = suite.get();
const validate = (value, name) => {
    res.value = suite(name, input);
};
watchEffect(async () => {
    if ((props.oper == "edit" || props.oper == "view") && props.id && props.modelValue) {
        loading.value = true;
        try {
            const {
                contacto_comercial_id,
                contacto_logistico_id,
                sector_economico_id,
                segmentacion_id,
                referencia,
                direccion,
                observaciones,
                latitud,
                longitud,
                contacto_comercial_nombre,
                contacto_comercial_tel,
                contacto_comercial_email,
                contacto_logistico_nombre,
                contacto_logistico_tel,
                contacto_logistico_email,
                A3_NOME,
                A3_COD,
                cliente,
                presupuestado,
            } = await ObraService.show(props.id);
            input.cliente_id = {
                value: cliente?.A1_COD,
                label: cliente?.A1_NOME,
            };
            input.contactoComercialId = contacto_comercial_id;
            input.contactoLogisisticoId = contacto_logistico_id;
            input.sector_economico_id = parseInt(sector_economico_id);
            input.direccion = direccion;
            input.latitud = latitud;
            input.longitud = longitud;
            input.segmentacionId = segmentacion_id;
            input.observaciones = observaciones;
            input.referencia = referencia;
            input.contacto_comercial_nombre = contacto_comercial_nombre;
            input.contacto_comercial_tel = contacto_comercial_tel;
            input.contacto_comercial_email = contacto_comercial_email;
            input.contacto_logistico_nombre = contacto_logistico_nombre;
            input.contacto_logistico_tel = contacto_logistico_tel;
            input.contacto_logistico_email = contacto_logistico_email;
            input.distribuidor_id = { label: A3_NOME, value: A3_COD };
            input.presupuestado = presupuestado;
            center.value = { lat: parseFloat(latitud), lng: parseFloat(longitud) };
            validate();
        } catch (error) {
            $q.notify({
                type: "negative",
                message: error.message,
            });
        } finally {
            loading.value = false;
        }
    }
});

// Progreso de validación
const validationProgress = computed(() => {
    const requiredFields = ['referencia', 'cliente_id', 'sector_economico_id', 'direccion'];
    let completed = 0;

    for (const field of requiredFields) {
        if (input[field]) completed++;
    }

    return completed / requiredFields.length;
});

onMounted(async () => {
    clearInput();
    validate();
});
//////// MAPA
const center = ref({ lat: -32.93243, lng: -68.79458 });
const apiKey = "AIzaSyDDUPZqkYwch0pYHORSPyW2WGy3M0rp_gE";
const mapRef = ref(null);
const mapZoom = ref(15);
const onMapClick = (e) => {
    const lat = e.latLng.lat();
    const lng = e.latLng.lng();
    input.latitud = lat;
    input.longitud = lng;
    center.value = { lat, lng };
    let geocoder = new google.maps.Geocoder();
    geocoder.geocode({ 'location': e.latLng }, (results, status) => {
        if (status === 'OK') {
            if (results[0]) {
                let r = results[0];
                input.direccion = r.formatted_address;
                validate(input.direccion, 'direccion');
            } else {
                window.alert('No results found');
            }
        } else {
            window.alert('Geocoder failed due to: ' + status);
        }
    });
};

const setDireccion = ({ geometry, formatted_address }) => {
    if (!geometry) return;
    center.value = geometry.location;
    input.latitud = geometry.location.lat();
    input.longitud = geometry.location.lng();
    input.direccion = formatted_address;
    validate(input.direccion, 'direccion');
};


const save = async () => {
    input.distribuidor_id = input.distribuidor_id
        ? input.distribuidor_id.value
        : null;
    if (props.oper == "edit") {
        await update();
    } else {
        await store();
    }
};
const update = async () => {
    loading.value = true;
    const cliente_id = input.cliente_id.value ? input.cliente_id.value : input.cliente_id;
    try {
        const { result } = await ObraService.update(props.id, { ...input, cliente_id });
        clearInput();
        emits("updated");
        emits("update:modelValue", false);
    } catch (e) {
        $q.notify({
            type: "negative",
            message: "Error en guardado",
        });
    } finally {
        loading.value = false;
    }
};

const store = async () => {
    loading.value = true;
    try {
        const cliente_id = input.cliente_id.value ? input.cliente_id.value : input.cliente_id;
        const { result } = await ObraService.store({ ...input, cliente_id });
        emits("stored", {
            "referencia": input.referencia,
            "id": result.id,
            "cliente_id": result.cliente_id,
            "cliente": cliente_id.label || cliente_id
        });
        emits("update:modelValue", false);
        clearInput();
    } catch (e) {
        console.log(e);
    } finally {
        loading.value = false;
    }
};
const clearInput = () => {
    input.cliente_id = "";
    input.contactoComercialId = "";
    input.contactoLogisisticoId = "";
    input.sector_economico_id = "";
    input.direccion = "";
    input.latitud = "";
    input.longitud = "";
    input.segmentacionId = "";
    input.observaciones = "";
    input.referencia = "";
    input.contacto_comercial_nombre = "";
    input.contacto_comercial_tel = "";
    input.contacto_comercial_email = "";
    input.contacto_logistico_nombre = "";
    input.contacto_logistico_tel = "";
    input.contacto_logistico_email = "";
    input.distribuidor_id = null;
    input.presupuestado = 0;
    res.value = suite.get();
};

const clienteUpdated = (cliente) => {
    input.cliente_id = {
        value: cliente?.value,
        label: cliente?.label,
    };
    validate(input.cliente_id, 'cliente_id');
    console.log("clienteUpdated");
};
watchEffect(() => {
    if (!props.modelValue) {
        clearInput();
    }
});
watchEffect(() => {
    if (input.cliente_id && props.oper == "add") {
        clientGetData(input.cliente_id);
    }
});
const clienteData = reactive({
    telefono: "",
    email: "",
});
const clientGetData = async (id) => {
    try {
        const {
            A1_TEL,
            A1_EMAIL,
            R_E_C_N_O_,
            A1_XTELCOM,
            A1_XCONCOM,
            A1_XEMAILC,
        } = await ClienteService.show(id);
        clienteData.id = R_E_C_N_O_;
        if (!input.contacto_comercial_nombre) {
            input.contacto_comercial_nombre = A1_XCONCOM.trim();
        }
        if (!input.contacto_comercial_tel) {
            input.contacto_comercial_tel = A1_XTELCOM.trim();
        }
        if (!input.contacto_comercial_email) {
            input.contacto_comercial_email = A1_XEMAILC.trim();
        }
        if (!input.contacto_logistico_tel) {
            input.contacto_logistico_tel = A1_TEL.trim();
        }
        if (!input.contacto_logistico_email) {
            input.contacto_logistico_email = A1_EMAIL.trim();
        }
        validate();
    } catch (error) {
        $q.notify({
            type: "negative",
            message: error.message,
        });
    }
};
</script>

<style lang="scss" scoped>
.obra-crud-form {
    border-radius: 16px;
    overflow: hidden;

    // Gradiente para el header
    .bg-gradient-primary {
        background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
    }

    // Toolbar fijo arriba
    .toolbar-fixed {
        flex-shrink: 0;
        position: sticky;
        top: 0;
        z-index: 100;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    // Contenido scrolleable
    .content-scrollable {
        flex: 1;
        overflow: hidden;
    }

    .scroll-area {
        overflow-y: auto;
        max-height: 100%;

        &::-webkit-scrollbar {
            width: 8px;
        }

        &::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 4px;
        }

        &::-webkit-scrollbar-thumb {
            background: #888;
            border-radius: 4px;

            &:hover {
                background: #555;
            }
        }
    }

    // Acciones fijas abajo
    .actions-fixed {
        flex-shrink: 0;
        box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
    }
}

// Sticky summary en desktop
.sticky-summary {
    position: sticky;
    top: 20px;
}

// Card de resumen
.summary-card {
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

// Filas del resumen
.summary-row {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 0;

    &:not(:last-child) {
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    }

    span:first-child {
        flex: 1;
    }

    span:last-child {
        text-align: right;
        word-break: break-word;
    }
}

.summary-section {
    margin-bottom: 8px;
}

// Mejora de tipografía
.text-white-7 {
    color: rgba(255, 255, 255, 0.7);
}

// Expansion items
:deep(.q-expansion-item) {
    border: 1px solid rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;

    &.q-expansion-item--expanded {
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    }

    .q-expansion-item__container {
        .q-item {
            min-height: 56px;
        }
    }
}

// Contenedor del mapa
.map-container {
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

// Responsive
@media (max-width: 1023px) {
    .obra-crud-form {
        border-radius: 0;
        max-width: 100vw !important;
    }

    .sticky-summary {
        position: relative;
        top: 0;
    }
}

// Animaciones
@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.obra-crud-form {
    animation: fadeIn 0.4s ease;
}
</style>
